<template>
  <router-view/>
  <ShowToast />
  <DynamicDialog />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  mounted() {
    this.axios.get('/sanctum/csrf-cookie').then(() => {
      console.log('sanctum/csrf-cookie ok')
    }).catch(() => {
      // window.location.reload()
    });
  },
})
</script>